import UdeskReact from 'udesk-react/src/udesk/react';
import component from './template';

export default UdeskReact.udeskify(component);